<label class="relative inline-block w-14 h-[30px]">
  <input type="checkbox" class="sr-only" [checked]="isChecked" (change)="toggle()">
  <span class="absolute inset-0 bg-gray-200 transition duration-200 ease-in-out rounded-md shadow-inner"
    [class.bg-green-400]="isChecked"></span>
  <span
    class="absolute left-[5px] top-0.5 bg-white w-6 h-[26px] rounded-md shadow transition-transform duration-200 ease-in-out"
    [style.transform]="isChecked ? 'translateX(100%)' : 'translateX(0)'"></span>
</label>
